<template>
  <div class="home">
    <!-- <div class="banner">
      <div class="banner-container">
        <div class="banner-info">
          <h3>
            CEATI联盟（网络安全威胁情报生态联盟 英文全称：Cybersecurity  Ecology Alliance of Threat Intelligence）
          </h3>
          <span>
            是由奇安信威胁情报中心联手国内多个著名安全公司共同发起的共建威胁情报行业生态的的联盟机构，旨在以威胁情报能力应用为核心，打造新生态圈模式，情报使能、共谋共策、开放合作、共赢未来。
          </span>
          <router-link :to="{ name: 'introuduce' }" class="learn-more">了解联盟</router-link>
        </div>
        <img src="../assets/images/banner.png" alt="">
      </div>
    </div> -->

    <!-- <div class="newBanner">
        <img src="../assets/images/newBanner-01.png" alt="">
    </div> -->

    <template>
      <div
        class="carousel-wrap"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <el-carousel
          ref="carousel"
          @change="handleCarouselChange"
          arrow="never"
          :height="carouselHeight"
          :autoplay="false"
        >
          <!-- <el-carousel-item>
            <div class="banner-new">
              <div class="banner-info">
                <p>2021年度的TI INSIDE威胁情报生态发布会：</p>
                <p>
                  TI
                  INSIDE威胁情报生态论坛，是利用威胁情报技术inside方式为产业赋能、以建设威胁情报生态为核心的论坛。
                </p>
                <p>
                  论坛致力于挖掘威胁情报使用效果及价值，以威胁情报能力应用为索引，共享情报与产品的融合实践经验、解决思路和技术途径；探索非对称网络空间的制胜谋略；共建威胁情报行业生态，提高国内安全防护水位，共筑安全堡垒。
                </p>
                <br />
                <p>亮点：</p>
                <p>
                  （1）TI
                  INSIDE威胁情报生态论坛，是全国范围内首个以建设威胁情报生态为核心的论。论坛由奇安信威胁情报中心联合国内多个著名安全公司共同举办。
                </p>
                <p>
                  （2）联盟成员威胁情实践产品发布：产品方向涵盖情报运营、APT跟踪、样本对抗、Web安全、数据安全、大数据分析、云安全、等保合规安全硬件等多项关键技术。
                </p>
                <p>
                  （3）吸纳威胁联盟新成员的加入：烽台科技、云智安信、吉沃科技等多家威胁联盟新成员加入。
                </p>
                <br />
                <p>
                  详情前往官网了解：
                  <a href="https://bcs.qianxin.com/" target="_blank"
                    >https://bcs.qianxin.com/</a
                  >
                </p>
              </div>
              <img src="../assets/images/newBanner-03.png" alt="" />
            </div>
          </el-carousel-item> -->
          <el-carousel-item v-for="(item, index) in bannerImg" :key="index">
            <div class="img-text-wrap">
              <div class="img-text">
                <div class="img-title">开源失陷检测离线包发布！</div>
                <div class="img-sub-title">
                  5W量级IOC检测离线包,奇安信威胁情报中心出品
                </div>
                <div class="img-sub-title">
                  更多联盟成员共享的威胁情报资源、工具，前往<router-link
                    to="redownload"
                    style="color: #0044cc"
                    >资源下载</router-link
                  >中心查看
                </div>
              </div>
              <img
                class="img"
                :ref="'img' + index"
                @click="handleImgClick(item)"
                :src="item"
                alt=""
              />
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="banner" :style="{ height: carouselHeight }" ref="img1">
              <div class="banner-container">
                <div class="banner-info">
                  <h3>
                    CEATI联盟（网络安全威胁情报生态联盟 英文全称：Cybersecurity
                    Ecology Alliance of Threat Intelligence）
                  </h3>
                  <span>
                    是由奇安信威胁情报中心联手国内多个著名安全公司共同发起的共建威胁情报行业生态的联盟机构，旨在以威胁情报能力应用为核心，打造新生态圈模式，情报使能、共谋共策、开放合作、共赢未来。
                  </span>
                  <router-link :to="{ name: 'introuduce' }" class="learn-more"
                    >了解联盟</router-link
                  >
                </div>
                <img src="../assets/images/banner.png" alt="" />
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="banner" :style="{ height: carouselHeight }" ref="img1">
                <a @click="goto('/redownload','mining')"><img src="../assets/images/banner3.png" alt="" width="100%" />
                </a>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="progress" :style="{ width: progressLength + '%' }"></div>
      </div>
    </template>

    <!-- <div id="owl-demo" class="owl-carousel" v-for="item in bannerImg" :key="item">
      <a class="item"><img :src="item" alt=""></a>
    </div> -->

    <div class="news" v-if="showNews">
      <div class="news-container">
        <div class="title">联盟新闻</div>
        <div class="news-list-container">
          <ul>
            <li v-for="item in newsList" :key="item.id">
              <h4 :title="item.title">{{ item.title }}</h4>
              <div class="extra">
                <span
                  >{{ dayjs(item.date_format).format("YYYY-MM-DD HH:mm") }} /
                  {{ item.author }}</span
                >
              </div>
              <p>
                {{ item.summary }}
              </p>
              <router-link
                :to="{ name: 'detail', params: { id: item.gid } }"
                class="view-detail"
                >查看详情</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="members-right">
      <div class="members-right-container">
        <div class="title">成员权益</div>
        <ul>
          <li v-for="(item, index) in memberRights" :key="index">
            <div class="members-right-title">
              <img v-if="item.title.img" :src="item.title.img" alt="" />
              <span v-else>{{ item.title.label }}</span>
            </div>
            <div class="member-right-desc">
              {{ item.desc }}
            </div>
            <div
              v-for="(pic, picIndex) in item.pics"
              :key="picIndex"
              class="member-pics"
            >
              <img :src="pic" alt="" />
            </div>
            <div class="member-right-list">
              <div v-for="(subDesc, descIndex) in item.list" :key="descIndex">
                {{ subDesc }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="members">
      <div class="members-container">
        <div class="title">联盟成员</div>
        <MemberList className="home-member"></MemberList>
      </div>
    </div>
    <div class="apply-form">
      <div class="apply-form-container">
        <div class="side">
          <h2>
            如果您还不是联盟成员，
            <br />
            并且想了解更多信息
          </h2>
          <a href="mailto:support@ceati.org.cn" class="contact-us"
            >请与我们联系</a
          >
        </div>
        <div class="main">
          <ApplyForm></ApplyForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { memberRights, bannerImg } from '@/utils/helper';
import ApplyForm from '@/components/ApplyForm.vue';
import MemberList from '@/components/MemberList.vue'
import { getNewsList } from '@/api/api';
import dayjs from 'dayjs';
// @ is an alias to /src
function throttle (func, wait) {
  let previous = 0;
  return function () {
    let now = Date.now();
    let context = this;
    let args = arguments;
    if (now - previous > wait) {
      func.apply(context, args);
      previous = now;
    }
  };
}
export default {
  name: 'home',
  components: {
    ApplyForm,
    MemberList
  },
  data () {
    return {
      memberRights,
      bannerImg,
      carouselHeight: '476px',
      newsList: [],
      showNews: false,
      progressLength: 0,
      timer: '',
      isPause: false,
      intervalTime: '',
      currentIndex: 0
    };
  },
  mounted () {
    window.onresize = throttle(this.handleScreenReisze, 200);
    if (this.bannerImg.length) {
      this.timer = setInterval(this.handleCarousel, 10);
    }
    const params = {
      // site: 'npYkMxv5ENMj4Wz3PK10',
      site: 'zgZbDQmr7lD7P8lV61vR',
      limit: 12
    };
    getNewsList(params).then((data) => {
      this.newsList = data.data.data;
      if (this.newsList.length) {
        this.showNews = true;
      }
    });
    // 图片加载后进行高度调整
    this.$refs['img' + 0][0].onload = () => {
      this.handleScreenReisze();
    };
  },
  beforeDestroy () {
    clearInterval(this.timer);
    window.onresize = null;
  },
  methods: {
    goto (page, selectId) {
      let path = page;
      localStorage.setItem('toId', selectId);
      this.$router.push({ path: path });
    },
    dayjs,
    handleImgClick (item) {
      // console.log(item, 'item')
    },
    handleScreenReisze (evt) {
      // this.currentIndex
      let height = this.$refs['img' + 0][0].offsetHeight;
      this.carouselHeight = (height > 320 ? height : 320) + 'px';
    },
    handleMouseEnter (evt) {
      this.isPause = true;
    },
    handleMouseLeave (evt) {
      this.isPause = false;
    },
    handleCarouselChange (index) {
      this.currentIndex = index;
      clearInterval(this.timer);
      this.progressLength = 0;
      this.timer = setInterval(this.handleCarousel, 10);
    },
    handleCarousel () {
      if (this.isPause === false) {
        this.progressLength += 0.2;
        if (this.progressLength >= 100) {
          this.$refs.carousel.next();
        }
      }
    }
    // handleCarousel (timeout = 5000) {
    //   this.timer = setTimeout(() => {
    //     if (this.currentIndex + 1 > this.bannerImg.length) {
    //       this.currentIndex = 0
    //     } else {
    //       this.currentIndex++
    //     }
    //     this.$refs.carousel.setActiveItem(this.currentIndex);

    //     this.handleCarousel()
    //   }, timeout);
    // }
  }
};
</script>

<style scoped lang="scss">
.img-text-wrap {
  position: relative;
  .img-text {
    text-align: left;
    position: absolute;
    color: #fff;
    top: 40%;
    left: 15%;
    font-size: 42px;
    .img-sub-title {
      padding-top: 20px;
      font-size: 20px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}
.carousel-wrap {
  position: relative;
  .img {
    width: 100%;
  }
  .progress {
    position: absolute;
    bottom: 0px;
    height: 3px;
    width: 100%;
    background: rgba($color: #fff, $alpha: 0.6);
    // background:red;
    z-index: 2;
  }
}
.home {
  min-width: 1200px;
  box-sizing: border-box;
}
.title {
  width: 1200px;
  height: 115px;
  margin: 0 auto;
  background-image: url(~@/assets/images/title-bg.png);
  color: #0b49c9;
  font-weight: bolder;
  line-height: 115px;
  font-size: 20px;
  margin: 50px 0;
}
.news {
  overflow: hidden;
  .news-container {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 64px;
  }
  .news-list-container {
    // height: 684px;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 366px;
    /* border: 1px solid red; */
    max-height: 700px;
  }
  ul {
    margin-right: -50px;
    padding: 10px;
  }
  li {
    float: left;
    position: relative;
    width: 368px;
    height: 324px;
    padding: 32px;
    margin: 0 35px 40px 0;
    background: #ffffff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
    h4 {
      font-size: 18px;
      color: #333333;
      text-align: left;
      line-height: 26px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .extra {
      font-size: 12px;
      color: #999999;
      text-align: left;
      margin: 16px 0;
      span {
        margin-right: 15px;
      }
    }
    p {
      font-size: 12px;
      color: #717171;
      text-align: left;
      line-height: 20px;
      height: 100px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
    }
    .view-detail {
      width: 96px;
      height: 32px;
      border: 1px solid #0044cc;
      font-size: 12px;
      color: #0044cc;
      line-height: 32px;
      display: block;
      position: absolute;
      bottom: 32px;
      &:hover {
        background-color: #ccddff;
      }
    }
  }
}
.members-right {
  overflow: hidden;
  background: url(~@/assets/images/members-right-bg.png) top right no-repeat
    #0c63d7;
  padding-bottom: 64px;
  .title {
    color: #ffffff;
  }
  .members-right-container {
    width: 1200px;
    margin: 0 auto;
  }
  ul {
    margin-right: -100px;
    li {
      float: left;
      width: 368px;
      height: 780px;
      background-color: #ffffff;
      margin-right: 48px;
      .members-right-title {
        height: 70px;
        display: flex;
        align-items: center;
        margin: 25px 0;
        img {
          display: flex;
          align-items: center;
          margin: 0 auto;
        }
        span {
          font-size: 24px;
          color: #0044cc;
          padding-left: 32px;
          font-weight: bold;
        }
      }
      .member-right-desc {
        height: 80px;
        font-size: 12px;
        color: #717171;
        text-align: left;
        line-height: 20px;
        padding: 0 32px;
        margin-bottom: 16px;
      }
      .member-pics {
        img {
          margin-bottom: 16px;
        }
      }
      .member-right-list {
        height: 200px;
        background-color: #d8b84e;
        text-align: left;
        padding: 20px 32px 0 32px;
        div {
          font-size: 12px;
          color: #ffffff;
          background: url(~@/assets/images/member-li-bg.png) left 2px no-repeat;
          padding-left: 30px;
          line-height: 20px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
.members {
  overflow: hidden;
  height: 752px;
  .members-container {
    width: 1200px;
    margin: 0 auto;
  }
}
.apply-form {
  background-color: #fbfbfb;
  height: 604px;
  .apply-form-container {
    width: 1200px;
    min-height: 690px;
    margin: 0 auto;
    overflow: hidden;
    padding: 10px;
    position: relative;
    top: -163px;
  }
  .side {
    float: left;
    background: url(~@/assets/images/apply-sidebar-bg.png) bottom center
      no-repeat #ffffff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
    width: 368px;
    height: 690px;
    // margin-right: 48px;
    padding: 64px 32px 0 32px;
    h2 {
      color: #333333;
      font-size: 24px;
      text-align: left;
      line-height: 36px;
    }
    .contact-us {
      background: #ffffff;
      border: 2px solid #0044cc;
      display: block;
      margin-top: 15px;
      font-size: 14px;
      color: #0044cc;
      line-height: 20px;
      width: 136px;
      height: 40px;
      line-height: 42px;
    }
  }
  .main {
    float: right;
    width: 784px;
  }
}
//幻灯片
.el-carousel__container {
  height: 400px;
}
.el-carousel__item h3 img {
  display: block;
  width: 100%;
  height: 100%;
}

.newBanner {
  // height: 400px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.banner {
  height: 400px;
  background-color: #ebf1ff;
  .banner-container {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    top: 80px;
    .banner-info {
      float: left;
      width: 656px;
      text-align: left;
      h3 {
        font-size: 24px;
        color: #333333;
        line-height: 36px;
        font-weight: bold;
      }
      span {
        font-size: 14px;
        color: #666666;
        line-height: 28px;
        margin-top: 20px;
        display: block;
      }
      .learn-more {
        display: block;
        width: 184px;
        height: 40px;
        line-height: 40px;
        background: url(~@/assets/images/join-us.png) no-repeat #0044cc;
        color: #ffffff;
        text-align: left;
        margin-top: 50px;
        padding-left: 54px;
        background-position: 115px;
        font-size: 14px;
      }
    }
  }
}

.banner-new {
  position: relative;

  .banner-info {
    width: 50%;
    text-align: left;
    padding-right: 60px;
    position: absolute;
    right: 9%;
    top: 20%;
    color: rgba(255, 255, 255, 0.8);

    p {
      line-height: 28px;
    }
    a {
      color: #fff;
    }
  }
  img {
    width: 100%;
  }
}
@media screen and (max-width: 1668px) {
  .banner-new {
    .banner-info {
      font-size: 12px;
      p{
        line-height: 16px;
      }
    }
  }
}
</style>
